import {
  getCatalogApi,
  getDetailShowApi,
  getNewApi,
  getPromotionApi,
  getPromotionParkApi,
  getShowNewApi,
} from 'app/services/showApi';
import { getTicketApi } from 'app/services/ticketApi';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  GET_CATALOGS,
  GET_DETAIL_SHOW,
  GET_LIST_PAYMENT_METHOD,
  GET_LIST_TICKET_FORM,
  GET_NEW,
  GET_PROMOTION,
  GET_PROMOTION_PARK,
  GET_SHOWS,
  GET_TICKETS,
} from '.';
import { selectOptionsGetTickets } from './selectors';
import { getPaymentMethodApi } from 'app/services/checkoutApi';

export function* getShows({ payload }: any) {
  const { onSuccess, onFailed, ...restParams } = payload;
  try {
    const searchParams = new URL(window.location.href).searchParams;
    const preview = searchParams.get('previewB2b');
    const params = { ...restParams, previewB2b: preview };
    const { data } = yield call(getShowNewApi, params);
    yield put(
      GET_SHOWS.success({
        shows: data.data,
        filters: { dates: data.dates || [], times: data.times || [] },
        paginator: data.paginator,
      }),
    );
    onSuccess?.();
  } catch (err) {
    yield put(GET_SHOWS.failure());
    onFailed?.();
  }
}
export function* getCatalogs({ payload }: any) {
  try {
    const { data } = yield call(getCatalogApi, payload);
    yield put(GET_CATALOGS.success(data.data));
  } catch (err) {
    yield put(GET_CATALOGS.failure());
  }
}

export function* getDetailShow({ payload }: any) {
  try {
    const { data } = yield call(getDetailShowApi, payload);
    yield put(GET_DETAIL_SHOW.success(data));
  } catch (err) {
    yield put(GET_DETAIL_SHOW.failure(err));
  }
}

export function* getTickets({ payload }: any) {
  try {
    const options = yield select(selectOptionsGetTickets);
    const { data } = yield call(getTicketApi, { ...options, payload });
    yield put(
      GET_TICKETS.success({ tickets: data.data, filters: data.filters }),
    );
  } catch (err) {
    yield put(GET_TICKETS.failure());
  }
}
export function* getNews({ payload }: any) {
  try {
    const { data } = yield call(getNewApi, payload);
    yield put(GET_NEW.success(data.data));
  } catch (err) {
    yield put(GET_NEW.failure());
  }
}
export function* getPromotionParks({ payload }: any) {
  try {
    const { data } = yield call(getPromotionParkApi, payload);
    yield put(GET_PROMOTION_PARK.success(data));
  } catch (err) {
    yield put(GET_PROMOTION_PARK.failure());
  }
}
export function* getPromotions({ payload }: any) {
  try {
    const { data } = yield call(getPromotionApi, payload);
    yield put(GET_PROMOTION.success(data.data));
  } catch (err) {
    yield put(GET_PROMOTION.failure());
  }
}
export function* getListPaymentMethod({ payload }: any) {
  try {
    const { data } = yield call(getPaymentMethodApi, payload);
    yield put(GET_LIST_PAYMENT_METHOD.success(data.data));
    yield put(GET_LIST_TICKET_FORM.success(data?.dataDeliverTicketType || []));
  } catch (err) {
    yield put(GET_LIST_PAYMENT_METHOD.failure());
  }
}
export function* catalogSaga() {
  yield takeLatest(GET_TICKETS.TRIGGER, getTickets);
  yield takeLatest(GET_SHOWS.TRIGGER, getShows);
  yield takeLatest(GET_DETAIL_SHOW.TRIGGER, getDetailShow);
  yield takeLatest(GET_CATALOGS.TRIGGER, getCatalogs);
  yield takeLatest(GET_NEW.TRIGGER, getNews);
  yield takeLatest(GET_PROMOTION_PARK.TRIGGER, getPromotionParks);
  yield takeLatest(GET_PROMOTION.TRIGGER, getPromotions);
  yield takeLatest(GET_LIST_PAYMENT_METHOD.TRIGGER, getListPaymentMethod);
}
